module.exports = __webpack_public_path__ + "img/preview-lg.ca1c0131.png";